import { Widget } from '@sprinklr/stories/widget/Widget';
import { Theme } from 'models/Theme/Theme';
import { CollapseProps, TunablesCollapse } from 'components/Sidebar/RenderTunables/RenderTunables';
import i18n from 'i18next';
import { headerTunables, opacityTunables } from 'components/Sidebar/RenderTunables/SharedTunables';
import {
    xAxisTunables,
    yAxisTunables,
    gridTunables,
    legendTunables,
    metaInfoTunables,
} from 'components/Sidebar/RenderTunables/HyperspaceSharedTunables';
import React from 'react';
import ActionCheckboxGroup from 'components/_UI/Forms/Actions/ActionCheckboxGroup';
import ActionSliderGroup from 'components/_UI/Forms/Actions/ActionSliderGroup';
import ActionMultiRadioGroup from 'components/_UI/Forms/Actions/ActionMultiRadioGroup';
import { FILL_TYPE_OPTIONS } from '@sprinklr/display-builder/widgets/hyperSpace/HyperSpaceAreaChartWidget/constants';

export const HyperSpaceAreaChartWidgetTunables = (
    widget: Widget,
    mergedTheme: Theme
): TunablesCollapse[] => [
    {
        props: {
            label: i18n.t('Area Chart'),
            startOpen: true,
        } as CollapseProps,
        children: [
            ...headerTunables(widget),
            opacityTunables(widget),
            <ActionCheckboxGroup
                key='widget.options.zeroFill'
                label={i18n.t('Zero Fill')}
                option={widget.options}
                value='zeroFill'
            />,
            gridTunables(widget),
        ],
    },
    {
        props: {
            label: i18n.t('Fill'),
            startOpen: true,
        } as CollapseProps,
        children: [
            <ActionMultiRadioGroup
                key='widget.options.baseXYChartOptions.fill.type'
                label={i18n.t('Type')}
                option={widget.options.baseXYChartOptions.fill}
                value='type'
                options={FILL_TYPE_OPTIONS}
            />,
            widget.options.baseXYChartOptions.fill.type === 'solid' && (
                <ActionSliderGroup
                    key='widget.options.baseXYChartOptions.fill.opacity'
                    label={i18n.t('Fill Opacity')}
                    option={widget.options.baseXYChartOptions.fill}
                    value='opacity'
                    showValue
                    min={0}
                    max={100}
                />
            ),
        ],
    },
    metaInfoTunables({ widget, color: true, image: false }),
    xAxisTunables({ widget, mergedTheme }),
    yAxisTunables({ widget, mergedTheme, axisIsDim: false }),
    legendTunables(widget),
];
